export const navList = [
  { status: 1, url: ["/"], img: "sy", pcImg: "sy-nav" },
  {
    status: 2,
    url: ["/race-news", "/news-detail"],
    img: "zx",
    pcImg: "zx-nav",
  },
  { status: 3, url: ["/race-video"], img: "sp", pcImg: "sp-nav" },
  { status: 4, url: ["/race-info"], img: "sm", pcImg: "sm-nav" },
  { status: 5, url: ["/race-honors"], img: "honor", pcImg: "honor-nav" },
];
